import { defineComponent, ref, toRefs, watch } from "@vue/composition-api";
import NotificationPopover from "@Shared/components/general/notification-popover.vue";
import { delay } from "@Shared/@Utils/utils";
export default defineComponent({
  name: "ApplicationSectionErrorIcon",
  components: {
    NotificationPopover
  },
  props: {
    id: {
      type: String,
      required: true
    },
    showErrors: {
      type: Number,
      default: 0
    },
    isFirstItem: {
      type: Boolean,
      default: false
    },
    noTooltip: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const {
      showErrors
    } = toRefs(props);
    const shake = ref(false);
    watch(showErrors, async newVal => {
      if (!newVal) return;
      shake.value = true;
      await delay(450);
      shake.value = false;
    });
    return {
      shake
    };
  }
});